module.exports = __webpack_public_path__ + "static/media/arrow-down.e755a04e.svg";